import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Dietitian } from 'src/app/data/dietitian/domain/dietitian';
import { Encouragement } from 'src/app/data/patient/domain/encouragement/encouragement';
import { Diary } from 'src/app/data/tracker/domain/diary/diary';
import { Picture } from 'src/app/data/tracker/domain/diary/picture';
import { DiaryType } from '../../../../data/tracker/domain/diary_type/diary_type';

export class EditComment {
  diary: Diary;
  comment: string;
}

@Component({
  // eslint-disable-next-line @angular-eslint/component-selector
  selector: 'msd-diary-day-column',
  templateUrl: './diary-day-column.component.html',
  styleUrls: ['./diary-day-column.component.scss'],
})
export class DiaryDayColumnComponent {
  @Input() name: string;
  @Input() day: number;
  @Input() encouragements: Encouragement[];
  @Input() entries: Diary[];
  @Input() dietitian?: Dietitian;
  @Input() diaryCommentLoadingId?: string;
  @Input() diaryTypes!: DiaryType[];
  @Output() onCommentEdit = new EventEmitter<EditComment>();
  @Output() onAi = new EventEmitter<Diary[]>();

  getPicturesUrls(pictures: Picture[]): string[] {
    return pictures?.map((p) => p.url);
  }

  commentEdit(diary: Diary, comment: string) {
    this.onCommentEdit.emit({
      diary,
      comment,
    });
  }

  testAi() {
    this.onAi.emit(this.entries);
  }
}
